import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from '../../forum/app';
import PaginatedListState from '../../common/states/PaginatedListState';
import EventEmitter from '../../common/utils/EventEmitter';
const globalEventEmitter = new EventEmitter();
export default class DiscussionListState extends PaginatedListState {
  constructor(params, page) {
    if (page === void 0) {
      page = 1;
    }
    super(params, page, null);
    _defineProperty(this, "extraDiscussions", []);
    _defineProperty(this, "eventEmitter", void 0);
    this.eventEmitter = globalEventEmitter.on('discussion.deleted', this.deleteDiscussion.bind(this));
  }
  get type() {
    return 'discussions';
  }
  requestParams() {
    // `filter` is cloned so extenders mutating it don't write back into
    // `this.params.filter` — that leak trips `paramsChanged()` on the next
    // mount and wipes the paginated cache (see #4583).
    const params = {
      include: ['user', 'lastPostedUser'],
      filter: _objectSpread({}, this.params.filter),
      sort: this.currentSort()
    };
    if (this.params.q) {
      params.filter.q = this.params.q;
      params.include.push('mostRelevantPost', 'mostRelevantPost.user');
    }
    return params;
  }
  loadPage(page) {
    if (page === void 0) {
      page = 1;
    }
    const preloadedDiscussions = app.preloadedApiDocument();
    if (preloadedDiscussions) {
      var _preloadedDiscussions;
      this.initialLoading = false;
      this.pageSize = ((_preloadedDiscussions = preloadedDiscussions.payload.meta) == null ? void 0 : _preloadedDiscussions.perPage) || DiscussionListState.DEFAULT_PAGE_SIZE;
      return Promise.resolve(preloadedDiscussions);
    }
    return super.loadPage(page);
  }
  clear() {
    super.clear();
    this.extraDiscussions = [];
  }

  /**
   * Get a map of sort keys (which appear in the URL, and are used for
   * translation) to the API sort value that they represent.
   */
  sortMap() {
    const map = {};
    if (this.params.q) {
      map.relevance = '';
    }
    map.latest = '-lastPostedAt';
    map.top = '-commentCount';
    map.newest = '-createdAt';
    map.oldest = 'createdAt';
    return map;
  }
  removeDiscussion(discussion) {
    this.eventEmitter.emit('discussion.deleted', discussion);
  }
  deleteDiscussion(discussion) {
    for (const page of this.pages) {
      const index = page.items.indexOf(discussion);
      if (index !== -1) {
        page.items.splice(index, 1);
        break;
      }
    }
    const index = this.extraDiscussions.indexOf(discussion);
    if (index !== -1) {
      this.extraDiscussions.splice(index);
    }
    m.redraw();
  }

  /**
   * Add a discussion to the top of the list.
   */
  addDiscussion(discussion) {
    this.removeDiscussion(discussion);
    this.extraDiscussions.unshift(discussion);
    m.redraw();
  }
  getAllItems() {
    return this.extraDiscussions.concat(super.getAllItems());
  }
  getPages() {
    const pages = super.getPages();
    if (this.extraDiscussions.length) {
      return [{
        number: -1,
        items: this.extraDiscussions
      }, ...pages];
    }
    return pages;
  }
}
flarum.reg.add('core', 'forum/states/DiscussionListState', DiscussionListState);